import axios from 'axios';
import axiosRetry from 'axios-retry'
import logHandling from './logHandling';

axiosRetry(axios, { retries: 3 });
// Exponential back-off retry delay between requests
axiosRetry(axios, { retryDelay: axiosRetry.exponentialDelay });

// GET USAGE axios.get(url[, config])
const axiosGet = (url, method, params) => {
  if (method === 'GET' && !!url.length) {
    const response = axios.get(url, params ? { params } : undefined);
    return (response);
  }
  logHandling('Fn axiosGet , parametros incorrectos ');
  Error('Parametros incorrectos');
};

/* Most of APIs I know use one of the following approaches for pagination:

offset and limit or
page and size */

const axiosGetPaginated = (url, page = 1, size = 100) => {
  if (!!url.length) {
    const response = axios.get({
      url: `${url}?page=${page}&size=${size}`,
    });
    return (response);
  }
  logHandling('Fn axiosGet , parametros incorrectos ');
  Error('Parametros incorrectos');
};

// Usage: axios.post(url[, data[, config]])
const axiosPost = (url, data) => {
  // const response = axios({
  //   url: url,
  //   method: "POST",
  //   data: JSON.stringify(data),
  // });
  const response = axios.post(url,JSON.stringify(data));
  return (response);
};

const axiosPostImg = (url, formData) => {
  const response = axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return (response);
};

/** DELETE */
const axiosDelete = (url) => {
  const response = axios({
    url: `${url}`,
    method: 'DELETE',
  });
  return (response);
};

/** PUT */
const axiosPut = (url, data) =>{
  const response = axios({
    url: `${url}`,
    method: 'PUT',
    data: JSON.stringify(data),
  });
  return (response);
};

/* Como Axios retorna una promesa, no es necesario crear otra como en la siguinte funcion */
// const axiosGet_deprecated = (url, method) => {
//   return new Promise((resolve, reject) => {
//     if (method === 'GET' && !!url.length) {
//       axios({
//         url: `${url}`,
//         method: "GET",
//       }).then(  (res) => {
//         if (res.length === 0){
//           reject(new Error('No existen datos'));
//         }
//         resolve(res.data);
//       })
//     }else{
//       logHandling('Fn axiosGet , parametros incorrectos ');
//       new Error('Parametros incorrectos');
//     }
//   });
// }

export {
  axiosGet, axiosPost, axiosDelete, axiosPut, axiosGetPaginated, axiosPostImg,
};
